<template>
  <div :class="!isDark ? 'loading-overlay' : 'loading-overlay-dark'">
    <div class="loading-container">
      <!-- Compact loading animation -->
      <div class="loading-spinner">
        <div class="spinner-ring">
          <div class="spinner-ring-inner"></div>
        </div>
      </div>
      
      <!-- Loading text -->
      <p class="loading-text">
        {{ $t("loading") }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  computed: {
    isDark() {
      return localStorage.getItem("theme") == "dark";
    },
  },
};
</script>

<style scoped>
/* Loading Overlay Styles - Low Opacity */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.loading-overlay-dark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

/* Loading Container */
.loading-container {
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem 2.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 200px;
}

.loading-overlay-dark .loading-container {
  background: rgba(30, 41, 59, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

/* Loading Spinner */
.loading-spinner {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-ring {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(59, 130, 246, 0.2);
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  position: relative;
}

.spinner-ring-inner {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 22px;
  height: 22px;
  border: 2px solid rgba(59, 130, 246, 0.1);
  border-top: 2px solid #60a5fa;
  border-radius: 50%;
  animation: spin 0.8s linear infinite reverse;
}

.loading-text {
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0;
  color: #374151;
  letter-spacing: 0.3px;
}

.loading-overlay-dark .loading-text {
  color: #e5e7eb;
}

/* Animations */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive Design */
@media (max-width: 480px) {
  .loading-container {
    padding: 1.5rem 2rem;
    max-width: 160px;
  }
  
  .spinner-ring {
    width: 32px;
    height: 32px;
  }
  
  .spinner-ring-inner {
    width: 18px;
    height: 18px;
    top: 5px;
    left: 5px;
  }
  
  .loading-text {
    font-size: 0.8rem;
  }
}

/* Hover effect for better interaction feedback */
.loading-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.loading-overlay-dark .loading-container:hover {
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
}
</style>
